module.exports = __webpack_public_path__ + "img/slide21-bubble-1-else.bd342388.png";